<template>
  <div class="Login">
    <v-form v-model="valid">
      <v-container>
        <v-layout row wrap>
          <div id="log">
            <h1 id="regHeading">Passwort vergessen? Setzen Sie hier bitte Ihr Neues:</h1>
            <v-divider></v-divider>
            <v-flex>
              <v-text-field label="Passwort *" class="txtField" :disabled="loading" v-model="password" :rules="[passwordRules.required, passwordRules.min]" required :type="'password'"></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field label="Passwort wiederholen *" :disabled="loading" :rules="[passwordRules.required, passwordRules.min, passwordConfirmationRule]" class="txtField" v-model="passwordRepeat" vid="confirmation" required :type="'password'"></v-text-field>
            </v-flex>
            <div v-if="!loading">
              <v-btn color="blue" @click="setPassword" :disabled="error || done" small class="ma-2">
                <span style="color: white;">Absenden</span>
              </v-btn>
            </div>
            <div v-else>
              <v-progress-linear
                color="blue accent-4"
                indeterminate
                rounded
                height="6"
              ></v-progress-linear>
            </div>
              <v-alert v-if="error && !loading" type="error" outlined>
                {{errText}}
              </v-alert>
              <v-alert v-if="!error && !loading && successText!==''" type="info" outlined>
                {{successText}}
              </v-alert>
          </div>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import {API_URL} from "../config";
import axios from 'axios'

export default {
  name: "password_forget",
  data() {
    return {
      loading: true,
      valid: false,
      error: false,
      done: false,
      errText: "",
      successText: "",
      password: "",
      passwordRepeat: "",
      passwordRules: {
        required: v => !!v || 'Passwort is erforderlich',
        min: v => v.length >= 8 || 'Passwort muss mindestens 8 Zeichen haben',
        emailMatch: () => "The email and password you entered don't match"
        // passwordConfirmationRule
      },
    };
  },
  computed: {
    passwordConfirmationRule() {
        return this.password === this.passwordRepeat || "Passwörter müssen übereinstimmen";
      },
  },
  mounted: function() {
     axios.get(API_URL + '/be/user/password_forget/' + this.$route.params.id).then((response) => {
        console.log('pw reset data: ', response.data)
        let data = response.data;
        this.loading = false
        if (data.used) {
          this.error = true
          this.errText = "Dieser Link wurde schon verwendet. Bitte erzeugen sie einen neuen unter Passwort vergessen!"
          return;
        }
        let time = new Date(data.issued_at);
        var maxtime = new Date(time);
        maxtime.setHours(time.getHours()+3);
        // maxtime.setHours(time.getHours()+3);
        if (Date.now() > maxtime.getTime()) {
          this.error = true
          this.errText = "Dieser gültigkeit dieses Links ist leider abgelaufen. Bitte erzeugen sie einen neuen unter Passwort vergessen!"
          return;
        }

        this.loading = false
      }).catch((res) => {
        let data = res.response.data
        this.loading = false;
        this.error = true
        this.errText = data.error
        console.log(res.response)
      })
  },
  methods: {
    setPassword() {
      console.log(this.valid);
      console.log(process);
      if (!this.valid) {
        return
      }

      var cred = { uuid: this.$route.params.id, 
        password: this.password }
      console.log('setPassword....', cred)

      this.loading = true;

      axios.post(API_URL + '/be/user/password_forget_set', cred).then((response) => {
        console.log('pw reset data: ', response.data)
        let data = response.data;
        this.loading = false
        this.done = true
        this.successText = data.message
      }).catch((res) => {
        this.loading = false;
        this.error = true
        this.errText = res.error
        console.log(res)
      })

    },
  }
};
</script>

<style>
.Login {
  text-align: center;
  opacity: 0.85;
  filter: alpha(opacity=85);
}

#log {
  background-color: white;
  width: 80%;
  margin: 5% auto 0% auto;
  border: 2px solid black;
  border-radius: 5px;
}

#regHeading {
  font-size: 200%;
}

#Login {
  float: left;
}

.txtField {
  width: 90%;
  margin-left: 5%;
}
</style>
